<template>
    <div>
        <a-modal 
        v-model="visible" 
        @ok="handleOk" 
        :width="iphone_screen" 
        :footer="null" 
        :dialog-style="{ top: '5px' }" 
        :class="this.$i18n.locale=='tc'?'font-NotoSansTC':'font-roboto'"
        :maskClosable="false">
            <template slot="title">
                <div id="modalTitle" v-html="$t('collectingInformation.ourclients2')" :class="this.$i18n.locale=='tc'?'titleFont_nt7':'titleFont_rb8'"></div>
            </template>
            <div class="stepComponent" v-show="this.current!==3">
                <a-steps :current="current" :direction="direction">
                    <a-step>
                        <template slot="title">
                            {{ $t('collectingInformation.aboutcompany') }}
                        </template>
                    <span slot="description">{{ $t('collectingInformation.aboutbusiness') }}</span>
                    </a-step>
                    <a-step :title="$t('collectingInformation.aboutproduct')" :description="$t('collectingInformation.understandneeds')" />
                    <a-step :title="$t('collectingInformation.contactfun')" :description="$t('collectingInformation.contactyou')" />
                </a-steps>
            </div>
            <div class="tip" v-show="this.current!==3">
                {{ $t('collectingInformation.providesuitable') }}
            </div>
            <div class="submitTip" v-show="this.current==3">
                <h2 :class="this.$i18n.locale=='tc'?'titleFont_nt7':'titleFont_rb7'">{{ $t('collectingInformation.confirmsubmit') }}</h2>
                <span v-html="$t('collectingInformation.followinginformation')"></span>
            </div>
            <div class="formmodal">
                <a-form-model layout="vertical" :model="form" ref="ruleForm" :rules="rules">
                    <div v-show="this.current==0||this.current==3">
                        <a-form-model-item
                        :label="$t('collectingInformation.companyname')"
                        prop="company_name"
                        >
                            <a-input v-model="form.company_name" :placeholder="$t('collectingInformation.entercompany')"/>
                        </a-form-model-item>
                        <a-form-model-item
                        :label="$t('collectingInformation.enterarea')"
                        prop="company_address"
                        style="padding: 0;"
                        >
                            <div class="countryTip">{{ $t('collectingInformation.entercountrytip') }}</div>
                            <a-select
                                show-search
                                :placeholder="$t('collectingInformation.selectarea')"
                                option-filter-prop="children"
                                :filter-option="filterOption"
                                v-model="form.company_address"
                            >
                                <a-select-option :value="item.domain_code+'-'+item.name_en" v-for="(item,index) in country" :key="index">
                                    +{{ item.phone_code }} {{ item.name_en }}
                                </a-select-option>
                            </a-select>
                        </a-form-model-item>
                        <a-form-model-item
                        :label="$t('collectingInformation.yearofcompany')"
                        prop="company_create_year"
                        >
                            <a-date-picker 
                            mode="year" 
                            :placeholder="$t('collectingInformation.selectyear2')" 
                            v-model="form.company_create_year" 
                            :format="monthFormat" 
                            :open="yearShowOne"
                            :allowClear="false"
                            :disabledDate="getDisabledDate"
                            @openChange="openChangeOne"
                            @panelChange="panelChangeOne"
                            />
                        </a-form-model-item>
                        <a-form-model-item
                        :label="$t('collectingInformation.companywebsite')"
                        prop="company_website"
                        >
                            <a-input v-model="form.company_website" placeholder="https://"/>
                        </a-form-model-item>
                    </div>
                    <div v-show="this.current==1||this.current==3">
                        <a-form-model-item
                        :label="$t('collectingInformation.saleschannels')"
                        prop="sales_channels"
                        >
                            <a-checkbox-group v-model="form.sales_channels" class="checkBox">
                                <div>
                                    <a-checkbox value="1" name="type">
                                        {{ $t('collectingInformation.ownedplatform') }}
                                    </a-checkbox>
                                </div>
                                <div>
                                    <a-checkbox value="2" name="type">
                                        {{ $t('collectingInformation.commerceplatform') }}
                                    </a-checkbox>
                                </div>
                                <div>
                                    <a-checkbox value="6" name="type">
                                        {{ $t('collectingInformation.travelplatform') }}
                                    </a-checkbox>
                                </div>
                                <div>
                                    <a-checkbox value="3" name="type">
                                        {{ $t('collectingInformation.mobileapplications') }}
                                    </a-checkbox>
                                </div>
                                <div>
                                    <a-checkbox value="4" name="type">
                                        {{ $t('collectingInformation.offlineretail') }}
                                    </a-checkbox>
                                </div>
                                <div style="margin-top: 0;">
                                    <a-row type="flex" align="top">
                                        <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" style="margin-top: 0;">
                                            <a-checkbox value="5" name="type">
                                                {{ $t('collectingInformation.otherchannels') }}
                                            </a-checkbox>
                                        </a-col>
                                        <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="this.form.sales_channels.indexOf('5') !== -1">
                                            <a-input v-model="form.other_sales_channels" :placeholder="$t('collectingInformation.pleaseenter')"/>
                                        </a-col>
                                    </a-row>
                                </div>
                            </a-checkbox-group>
                        </a-form-model-item>
                        <a-form-model-item
                        :label="$t('collectingInformation.monthlyquantity')"
                        prop="monthly_sales_range"
                        >
                        <a-radio-group v-model="form.monthly_sales_range" >
                            <a-radio :style="radioStyle" :value="1">
                                {{ $t('collectingInformation.Belownum') }}
                            </a-radio>
                            <div class="radioTip" v-if="this.form.monthly_sales_range==1">
                                {{ $t('collectingInformation.newopportunities') }}{{ $t('collectingInformation.startedquickly') }}
                            </div>
                            <a-radio :style="radioStyle" :value="2">
                                {{ $t('collectingInformation.numtonum') }}
                            </a-radio>
                            <div class="radioTip" v-if="this.form.monthly_sales_range==2">
                                {{ $t('collectingInformation.marketfoundation') }}{{ $t('collectingInformation.sustainedgrowth') }}
                            </div>
                            <a-radio :style="radioStyle" :value="3">
                                {{ $t('collectingInformation.orabove') }}
                            </a-radio>
                            <div class="radioTip" v-if="this.form.monthly_sales_range==3">
                                {{ $t('collectingInformation.forwardrapidly') }}{{ $t('collectingInformation.specification') }}
                            </div>
                        </a-radio-group>
                        </a-form-model-item>
                        <a-form-model-item
                        :label="$t('collectingInformation.wishproduct')"
                        prop="product_types"
                        >
                        <a-checkbox-group v-model="form.product_types" class="checkBox">
                                <div>
                                    <a-checkbox value="1">
                                        {{ $t('collectingInformation.esim') }}
                                    </a-checkbox>
                                </div>
                                <div>
                                    <a-checkbox value="2">
                                        {{ $t('collectingInformation.physical') }}
                                    </a-checkbox>
                                </div>
                            </a-checkbox-group>
                        </a-form-model-item>
                    </div>
                    <div v-show="this.current==2||this.current==3">
                        <a-form-model-item
                        :label="$t('collectingInformation.aboutTSim')"
                        prop="about_tsim"
                        >
                            <a-checkbox-group v-model="form.about_tsim" class="checkBox" @change="chengeCheckBox">
                                <div style="margin-top: 0;">
                                    <a-row type="flex" align="top" style="margin-top: 0;">
                                        <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" style="margin-top: 0;">
                                            <a-checkbox value="1" name="type">
                                                {{ $t('collectingInformation.socialMedia') }}
                                            </a-checkbox>
                                        </a-col>
                                        <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="this.form.about_tsim.indexOf('1') !== -1">
                                            <a-form-model-item
                                                prop="social_platform"
                                                style="margin: 0;"
                                            >
                                                <a-input v-model="form.how_to_know_tsim.social_platform.detail" :placeholder="$t('collectingInformation.entersouce')"/>
                                            </a-form-model-item>
                                        </a-col>
                                    </a-row>
                                </div>
                                <div>
                                    <a-row type="flex" align="top">
                                        <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" style="margin-top: 0;">
                                            <a-checkbox value="2" name="type">
                                                {{ $t('collectingInformation.onlinePlatform') }}
                                            </a-checkbox>
                                        </a-col>
                                        <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="this.form.about_tsim.indexOf('2') !== -1">
                                            <a-form-model-item
                                                prop="third_party_ecommerce"
                                                style="margin: 0;"
                                            >
                                                <a-input v-model="form.how_to_know_tsim.third_party_ecommerce.detail" :placeholder="$t('collectingInformation.enterplatform')"/>
                                            </a-form-model-item>
                                        </a-col>
                                    </a-row>
                                </div>
                                <div>
                                    <a-row type="flex" align="top">
                                        <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" style="margin-top: 0;">
                                            <a-checkbox value="3" name="type">
                                                {{ $t('collectingInformation.referral') }}
                                            </a-checkbox>
                                        </a-col>
                                        <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="this.form.about_tsim.indexOf('3') !== -1">
                                            <a-form-model-item
                                                prop="friend_recommendation"
                                                style="margin: 0;"
                                            >
                                                <a-input v-model="form.how_to_know_tsim.friend_recommendation.detail" :placeholder="$t('collectingInformation.enterreferral')"/>
                                            </a-form-model-item>
                                        </a-col>
                                    </a-row>
                                </div>
                                <div style="margin-top: 0;">
                                    <a-row type="flex" align="top">
                                        <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" style="margin-top: 0;">
                                            <a-checkbox value="4" name="type">
                                                {{ $t('collectingInformation.other') }}
                                            </a-checkbox>
                                        </a-col>
                                        <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="this.form.about_tsim.indexOf('4') !== -1">
                                            <a-form-model-item
                                                prop="other_input"
                                                style="margin: 0;"
                                            >
                                                <a-input v-model="form.other_input" @change="synchro_otherInputdata" :placeholder="$t('collectingInformation.briefdescription')"/>
                                            </a-form-model-item>
                                        </a-col>
                                    </a-row>
                                </div>
                            </a-checkbox-group>
                        </a-form-model-item>
                        <a-form-model-item
                        :label="$t('collectingInformation.contactname')"
                        prop="contact_name"
                        >
                            <a-input v-model="form.contact_name" :placeholder="$t('collectingInformation.enteryourname')"/>
                        </a-form-model-item>
                        <a-form-model-item
                        :label="$t('collectingInformation.email')"
                        prop="contact_email"
                        style="margin-bottom: 5px;"
                        >
                            <a-row type="flex" align="middle">
                                <a-col :xs="24" :sm="24" :md="24" :lg="13" :xl="13">
                                    <a-input v-model="form.contact_email" :placeholder="$t('collectingInformation.enteryouremail')"/>
                                </a-col>
                                <a-col :xs="24" :sm="24" :md="24" :lg="10" :xl="10" :class="isCountingDown?'disabledBtn':'getCodeBtn'">
                                    <a-button type="primary" v-debounce="[()=>{getCode()},1000]"  :disabled="isCountingDown">
                                        {{ isCountingDown ? `${countdown} ${this.$t('collectingInformation.sec')}` : $t('collectingInformation.getcode') }}
                                    </a-button>
                                </a-col>
                            </a-row>
                        </a-form-model-item>
                        <a-form-model-item
                        prop="email_verify_code"
                        >
                            <a-input v-model="form.email_verify_code" :placeholder="$t('collectingInformation.entercode')"/>
                        </a-form-model-item>
                        <a-form-model-item
                        :label="$t('collectingInformation.phonenumber')"
                        prop="contact_phone"
                        style="margin-bottom: 10px;"
                        >
                            <a-row type="flex" align="middle">
                                <a-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                                    <a-select
                                        show-search
                                        :placeholder="$t('collectingInformation.areacode')"
                                        option-filter-prop="children"
                                        :filter-option="filterOption2"
                                        v-model="form.countryCode"
                                        :allowClear="true"
                                    >
                                        <a-select-option :value="item.zone+'-'+item.code" v-for="(item,index) in countryCode" :key="index+item.code">
                                            {{ '+'+item.zone }}
                                        </a-select-option>
                                    </a-select>
                                </a-col>
                                <a-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16">
                                    <a-input v-model="form.contact_phone" :placeholder="$t('collectingInformation.enterphone')"/>
                                </a-col>
                            </a-row>
                        </a-form-model-item>
                    </div>
                    <a-form-model-item
                    v-show="current==3"
                    prop="is_agree"
                    style="margin-bottom: 10px;"
                    >
                        <a-checkbox-group v-model="form.is_agree">
                            <a-checkbox value="1" name="type">
                                <label>
                                    <span v-if="this.$i18n.locale=='tc'">我已閱讀並同意<span @click.stop="showAgreement" class="agreementText">保密協定</span></span>
                                    <span v-if="this.$i18n.locale=='en'">I have read and agreed to the <span @click.stop="showAgreement" class="agreementText">confidentiality agreement</span>.</span>
                                    <span v-if="this.$i18n.locale=='jp'">私は<span @click.stop="showAgreement" class="agreementText">秘密保持契約</span>を読み、同意しました。</span>
                                    <span v-if="this.$i18n.locale=='kr'">저는 <span @click.stop="showAgreement" class="agreementText">비밀유지계약서</span>를 읽고 동의하였습니다.</span>
                                </label>
                            </a-checkbox>
                        </a-checkbox-group>
                    </a-form-model-item>
                    <a-form-model-item>
                        <div class="submitBtn">
                            <a-row>
                                <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" class="backBtn">
                                    <a-button type="primary" @click="()=>{this.current--}" v-if="this.current&&this.current!==3">
                                        {{ $t('collectingInformation.back') }}
                                    </a-button>
                                </a-col>
                                <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                                    <a-button type="primary" v-debounce="[()=>{handleSubmit()},1000]" :loading="loading">
                                        {{ this.current==3?$t('collectingInformation.confirm'):this.current==2?$t('collectingInformation.submit'):$t('collectingInformation.next') }}
                                    </a-button>
                                </a-col>
                            </a-row>
                        </div>
                        
                    </a-form-model-item>
                </a-form-model>
            </div>
        </a-modal>
        <a-modal v-model="visible2"  @ok="handleOk2" :width="iphone_screen" :footer="null" :class="this.$i18n.locale=='tc'?'font-NotoSansTC':'font-roboto'">
            <template slot="title">
                <div id="modalTitle" v-html="$t('collectingInformation.ourclients2')" :class="this.$i18n.locale=='tc'?'titleFont_nt7':'titleFont_rb8'"></div>
            </template>
            <div class="successTip">
                <p>
                <a-icon type="check-circle" :style="{ fontSize: '62px', color: '#56c568' }"/>
            </p>
            <p :style="{color: '#56c568',fontSize: '28px',fontFamily:this.$i18n.locale=='tc'?'NotoSansTC-Bold':'Roboto-Bold'}">
                {{ $t('collectingInformation.wellreceived') }}
            </p>
            <p style="font-size: 24px;">
                {{ $t('collectingInformation.keepcontact') }}
            </p>
            </div>
        </a-modal>
        <a-modal v-model="visible3"  @ok="handleOk3" :width="iphone_screen" :footer="null" :dialog-style="{ top: '5px' }" class="font-roboto">
            <template slot="title">
                <div id="modalTitle" v-html="$t('collectingInformation.ourclients2')" :class="this.$i18n.locale=='tc'?'titleFont_nt7':'titleFont_rb8'"></div>
            </template>
            <div>
                <h2 style="text-align: center;">Mutual Non-Disclosure Agreement</h2>
                <p>
                    This Mutual Non-Disclosure Agreement (the “Agreement”) is entered into by the undersigned parties (the “Parties”) for the purpose of protecting confidential information during negotiations related to potential cooperation (the “Transaction”).
                </p>
                <h3>
                    1. Definition of Confidential Information
                </h3>
                <p>
                    1.1 <b>Confidential Information</b> refers to any and all information disclosed by one Party (the "Disclosing Party") to the other Party (the "Receiving Party"), including but not limited to business strategies, financial data, operational methods, intellectual property, and any other proprietary information.<br/>
                    1.2 Confidential Information does not include information that is publicly available or that the Receiving Party can demonstrate was obtained from a third party without a breach of confidentiality.
                </p>
                <h3>2. Obligations of the Receiving Party</h3>
                <p>
                    2.1 The Receiving Party agrees to use the Confidential Information solely for the purpose of evaluating the Transaction and shall:
                    <ul>
                        <li>Disclose the Confidential Information only to those representatives who need to know for the Permitted Purpose;</li>
                        <li>Clearly mark any disclosed information as "Confidential";</li>
                        <li>Inform representatives of the confidential nature of the information and ensure their compliance with this Agreement;</li>
                        <li>Immediately notify the Disclosing Party of any unauthorized disclosure or use of Confidential Information.</li>
                    </ul>
                </p>
                <h3>
                    3. Non-Disclosure
                </h3>
                <p>
                    3.1 The Receiving Party shall not disclose, reproduce, or communicate any Confidential Information to any third party without the prior written consent of the Disclosing Party.<br/>
                    3.2 If required by law to disclose any Confidential Information, the Receiving Party shall limit the disclosure to the minimum necessary and shall notify the Disclosing Party prior to such disclosure.
                </p>
                <h3>
                    4. Liability for Breach
                </h3>
                <p>
                    4.1 The Receiving Party shall be liable for any damages resulting from a breach of this Agreement and shall indemnify the Disclosing Party for any losses incurred.
                </p>
                <h3>
                    5. Term and Termination
                </h3>
                <p>
                    5.1 This Agreement shall remain in effect for a term of two (2) years from the Effective Date, and the confidentiality obligations shall continue indefinitely.
                </p>
                <h3>
                    6. General Provisions
                </h3>
                <p>
                    6.1 All Confidential Information remains the property of the Disclosing Party, and the Receiving Party shall return all copies upon request.
                    6.2 The Disclosing Party makes no representations or warranties regarding the accuracy of the Confidential Information.
                    6.3 This Agreement shall be governed by the laws of the Hong Kong Special Administrative Region.
                    6.4 Any amendments to this Agreement must be made in writing and signed by both Parties.
                    6.5 Any amendments must be in writing and signed by both Parties.
                    6.6 The Receiving Party may not assign its rights or obligations without consent from the Disclosing Party.
                    6.7 Each Party will bear its own expenses related to this Agreement.
                    6.8 This Agreement shall be governed under the laws of the HKSAR.
                    6.9 Disputes will be resolved through amicable negotiations or through arbitration in accordance with Hong Kong arbitration rules, in English.
                </p>
                <p>
                    <b>
                        By checking the box below, the undersigned parties acknowledge that they have read, understood, and agree to the terms of this Mutual Non-Disclosure Agreement.
                    </b>
                </p>
            </div>
        </a-modal>
    </div>
</template>

<script>
import countryCode from './phoneCode.js';
import moment from "moment";
import { sendChannelEmailVerifyCode,becomeChannel,getCountry } from '@/api/collectionInfo'
import { validateSpecialAndHttp,validateEmail,validateFiveDigitNumber,checkIsIPhone,validateURL } from '@/utils/reg'
    export default {
        data() {
            let validateCompany_name = (rule, value, callback) => {
                if (!value) {
                    callback(new Error(this.$t('collectingInformation.entercompany')));
                }else if(!validateSpecialAndHttp(value)){
                    callback(new Error(this.$t('collectingInformation.correctcompany')));
                }else callback()
            };
            let validateCompany_address = (rule, value, callback) => {
                if (!value) {
                    callback(new Error(this.$t('collectingInformation.selectarea')));
                }else callback()
            };
            let validateCompany_create_year = (rule, value, callback) => {                
                if (!value) {
                    callback(new Error(this.$t('collectingInformation.selectyear')));
                }else callback()
            };
            let validateCompany_website = (rule, value, callback) => {
                if (!validateURL(value)) {
                    callback(new Error(this.$t('collectingInformation.enterwebsite')));
                }else callback()
            };
            let validateSales_channels = (rule, value, callback) => {
                if (!value||!value.length) {
                    callback(new Error(this.$t('collectingInformation.selectsalef')));
                }else callback()
            };
            let validateMonthly_sales_range = (rule, value, callback) => {
                if (!value) {
                    callback(new Error(this.$t('collectingInformation.selectmonthsales')));
                }else callback()
            };
            let validateProduct_types = (rule, value, callback) => {
                if (!value||!value.length) {
                    callback(new Error(this.$t('collectingInformation.selecthopeType')));
                }else callback()
            };
            
            let validateSales_about_tsim = (rule, value, callback) => {
                if (!value||!value.length) {
                    callback(new Error(this.$t('collectingInformation.heardaboutTSim')));
                }else callback()
            };
            let validateother = (rule, value, callback) => {
                if (!value) {
                    callback(new Error(this.$t('collectingInformation.pleaseenter')));
                }else callback()
            };
            let validateContact_name = (rule, value, callback) => {
                if (!value) {
                    callback(new Error(this.$t('collectingInformation.enteryourname')));
                }else if(!validateSpecialAndHttp(value)){
                    callback(new Error(this.$t('collectingInformation.correctname')));
                }else callback()
            };
            let validatecontact_email = (rule, value, callback) => {
                if (!value) {
                    callback(new Error(this.$t('collectingInformation.enteryouremail')));
                }else if(!validateEmail(value)){
                    callback(new Error(this.$t('collectingInformation.correctemail')));
                }else callback()
            };
            let validateEmail_verify_code = (rule, value, callback) => {
                if (!value) {
                    callback(new Error(this.$t('collectingInformation.entercode')));
                }else if(!validateFiveDigitNumber(value)){
                    callback(new Error(this.$t('collectingInformation.correctverification')));
                }else callback()
            };
            let validateIs_agree = (rule, value, callback) => {
                if (!value||!value.length) {
                    callback(new Error(this.$t('collectingInformation.confirmagreement')));
                }else callback()
            };
            return {
                visible: false,
                visible2: false,
                visible3: false,
                direction:'horizontal',
                iphone_screen:window.innerWidth,
                current:0,
                queryParam:{},
                token:'',
                loading:false,
                form: {
                    sales_channels:[],
                    about_tsim:[],
                    company_website:'',
                    contact_phone:'',
                    countryCode:undefined,
                    company_create_year:'',
                    other_sales_channels:'',
                    other_input:'',
                    how_to_know_tsim:{
                        social_platform:{
                            selected: false,
                            detail: ""
                        },
                        third_party_ecommerce: {
                            selected: false,
                            detail: ""
                        },
                        friend_recommendation: {
                            selected: false,
                            detail: ""
                        },
                        other: {
                            selected: false,
                            detail: ""
                        }
                    }
                },
                radioStyle: {
                    display: 'block',
                    height: '30px',
                    lineHeight: '30px',
                },
                rules: {
                    company_name: [{ required: true,validator: validateCompany_name, trigger: 'blur' },],
                    company_address: [{ required: true, validator: validateCompany_address, trigger: 'blur' }],
                    company_create_year: [{ required: true, validator: validateCompany_create_year, trigger: 'blur' }],
                    company_website: [{ validator: validateCompany_website, trigger: 'blur' },],
                    sales_channels: [{ required: true,validator: validateSales_channels, trigger: 'change' }],
                    monthly_sales_range: [{ required: true, validator: validateMonthly_sales_range, trigger: 'change' }],
                    product_types: [{ required: true, validator: validateProduct_types, trigger: 'change' }],
                    contact_name: [{ required: true, trigger: 'blur',validator: validateContact_name }],
                    contact_email: [{ required: true, trigger: 'blur',validator:validatecontact_email }],
                    email_verify_code: [{ required: true, trigger: 'blur',validator:validateEmail_verify_code }],
                    contact_phone: [{ required: false, message: 'Please input activity form', trigger: 'blur' }],
                    is_agree:[{ required: true, validator:validateIs_agree, trigger: 'change' }],
                    about_tsim: [{ required: true,validator: validateSales_about_tsim, trigger: 'change' }],
                    other_input: [{ required: true, validator: validateother, trigger: 'blur' }],
                    social_platform: [{ required: false,  trigger: 'blur' }],
                    third_party_ecommerce: [{ required: false,  trigger: 'blur' }],
                    friend_recommendation: [{ required: false,  trigger: 'blur' }],
                },
                monthFormat: 'YYYY',
                country:[],
                countryCode,
                yearShowOne:false,
                year:'',
                countdown: 60,       // 倒计时秒数
                isCountingDown: false, // 控制按钮是否禁用
                timer: null           // 定时器
            };
        },
        mounted () {
            this.checkIphone()
            this.getCountryArray()
        },
        methods: {
            getCountryArray(){
                getCountry().then(res=>{
                    this.country = res.result.list
                })
            },
            showAgreement(){
                this.visible3 = true
            },
            checkIphone(){
                if(checkIsIPhone()||window.innerWidth<769){
                    this.direction = 'vertical'
                    this.iphone_screen = window.innerWidth
                }else{
                    this.direction = 'horizontal'
                    this.iphone_screen = 800
                }
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            filterOption2(input, option) {
                return (
                    option.componentOptions.children[0].text.indexOf(input) >= 0
                );
            },
            showModal() {
                this.visible = true;
            },
            handleOk(e) {
                this.visible = false;
            },
            handleOk2(e) {
                this.visible2 = false;
            },
            handleOk3(e) {
                this.visible2 = false;
            },
            handleSubmit(e){
                try{
                    if(this.current==0){
                    let true_num = 0
                    if(!this.form.company_create_year){//mode改为year之后form无法自动验证，只能手动验证
                        this.$refs.ruleForm.validateField('company_create_year',(valid)=>{})
                    }else{
                        true_num++
                    }
                    this.$refs.ruleForm.validateField(['company_name','company_address','company_website'],(valid) => {
                        if (!valid) {
                            true_num++
                            if(true_num>=4){
                                this.current++
                                this.$nextTick(() => {
                                    //延迟触发避免数据未加载
                                    const element = document.getElementById("modalTitle");
                                    element.scrollIntoView({
                                        behavior: "smooth",
                                        block: "start",
                                    });
                                });
                            }
                        }
                    });
                }else if(this.current==1){
                    let true_num = 0
                    this.$refs.ruleForm.validateField(['sales_channels','monthly_sales_range','product_types'],(valid) => {
                        if (!valid) {
                            true_num++
                            if(true_num>=3){
                                this.current++
                                this.$nextTick(() => {
                                    //延迟触发避免数据未加载
                                    const element = document.getElementById("modalTitle");
                                    console.log(element);
                                    
                                    element.scrollIntoView({
                                        behavior: "smooth",
                                        block: "start",
                                    });
                                });
                            }
                        }
                    });
                }else if(this.current==2){
                    let true_num = 0
                    let requiredArray = ['about_tsim','contact_name','contact_email','email_verify_code']
                    if(this.form.about_tsim.includes('4')){
                        requiredArray.push('other_input')
                    }
                    this.$refs.ruleForm.validateField(requiredArray,(valid) => {
                        if (!valid) {
                            true_num++
                            if(true_num>=requiredArray.length){
                                this.current++
                                this.$nextTick(() => {
                                    //延迟触发避免数据未加载
                                    const element = document.getElementById("modalTitle");
                                    element.scrollIntoView({
                                        behavior: "smooth",
                                        block: "start",
                                    });
                                });
                            }
                        }
                    });
                }else if(this.current==3){
                    this.$refs.ruleForm.validate((vaild) =>{
                        if(vaild){
                            this.loading = true
                            let formCopy = {...this.form}
                            formCopy.countryCode = formCopy.countryCode?formCopy.countryCode.split('-')[0]+'-':''
                            formCopy.company_address = formCopy.company_address.split('-')[0]
                            formCopy.sales_channels = formCopy.sales_channels.toString()
                            formCopy.product_types = formCopy.product_types.toString()
                            formCopy.contact_phone = formCopy.contact_phone?formCopy.countryCode + formCopy.contact_phone:'';
                            becomeChannel(formCopy).then(res=>{
                                // 定义错误代码与对应处理的映射
                                const errorCodes = [1201, 1202, 1203, 1204];

                                // 判断响应的代码
                                if (res.code === 1) {
                                    this.current = 0;
                                    this.stopCountdown();
                                    this.form.countryCode = undefined;
                                    this.visible = false;
                                    this.visible2 = true;
                                    this.$refs.ruleForm.resetFields();
                                } else if (errorCodes.includes(res.code)) {
                                    this.$message.error(res.msg);
                                }
                                this.loading = false
                            })
                            console.log(this.form);
                        }else{
                            console.log('err');
                            
                        }
                    })
                  }else return
                }catch(err){
                    console.log(err);
                    
                }
            },
            synchro_otherInputdata(){
                this.form.how_to_know_tsim.other.detail = this.form.other_input
            },
            chengeCheckBox(value) {
                const inputMapping = {
                    '1': 'social_platform',
                    '2': 'third_party_ecommerce',
                    '3': 'friend_recommendation',
                    '4': 'other'
                };

                Object.keys(inputMapping).forEach((key) => {
                    if(value.includes(key)){
                        this.form.how_to_know_tsim[inputMapping[key]].selected = true;
                    }else if(!value.includes('4')){
                        this.form.how_to_know_tsim[inputMapping[key]].selected = false;
                        this.form.how_to_know_tsim.other.detail = ''
                        this.form.other_input = ''
                    }else{
                        this.form.how_to_know_tsim[inputMapping[key]].detail = '';
                        this.form.how_to_know_tsim[inputMapping[key]].selected = false;
                    }
                });
            },
            getDisabledDate(current){
                return current > moment().subtract(0, "day"); //今天之后的年月日不可选，不包括今天
            },
            openChangeOne(status) {
                if (status) {
                    this.yearShowOne = true;
                }else{
                    this.yearShowOne = false;
                }
            },
            // 得到年份选择器的值
            panelChangeOne(value) {
                this.form.company_create_year = moment(value).format('YYYY')
                this.yearShowOne = false
                this.$nextTick(() => {
                    this.$refs.ruleForm.clearValidate('company_create_year');
                });
            },
            getCode(){
                this.$refs.ruleForm.validateField('contact_email',(valid) => {
                    if (!valid) {
                        sendChannelEmailVerifyCode({contact_email:this.form.contact_email}).then(res=>{
                            if(res.code==1){
                                this.startCountdown()
                            }
                        })
                    }else{
                        console.log('send fail');
                    }
                });
            },
            startCountdown() {
                // 如果倒计时已在进行中，则不再启动新的计时
                if (this.isCountingDown) return;

                // 启动倒计时
                this.isCountingDown = true;
                this.timer = setInterval(() => {
                    if (this.countdown > 0) {
                    this.countdown--;
                    } else {
                    this.stopCountdown();
                    }
                }, 1000);
            },
            stopCountdown() {
                // 停止倒计时
                clearInterval(this.timer);
                this.timer = null;
                this.countdown = 60;
                this.isCountingDown = false;
            },
        },
    }
</script>

<style lang="less" scoped>
.font-roboto{
        font-family: 'Roboto-Regular';
}
.font-NotoSansTC{
    font-family: 'NotoSansTC-Regular';
}

.titleFont_rb8{
    font-family: 'Roboto-ExtraBold';
}
.titleFont_rb7{
    font-family: 'Roboto-Bold';
}
.titleFont_nt7{
    font-family: 'NotoSansTC-Bold';
}
.titleFont_rb6{
    font-family: 'Roboto-SemiBold';
}
.titleFont_nt6{
    font-family: 'NotoSansTC-SemiBold';
}
.titleFont_rb5{
    font-family: 'Roboto-Medium';
}
.titleFont_nt5{
    font-family: 'NotoSansTC-Medium';
}
.formmodal{
    width: 80%;
    // padding: 0 30px;
    margin: 0 auto;
    margin-top: 20px;
}

/deep/#modalTitle{
    padding-top: 18px;
    padding-bottom: 10px;
    color: #484b4f;
    font-size: 15px;
    border-bottom: 1px solid #e7dfd4;
    span{
        font-size: 20px;
        color: #f49b23;
    }
}

.countryTip{
    margin: -7px 0 6px 0;
    padding-left: 10px;
    color: #8c8c8c;
    line-height: 16px;
    font-size: 14px;
}

.tip{
    margin-top: 15px;
    font-size: 11px;
    line-height: 20px;
    color: #000000;
}

/deep/.submitTip{
    line-height: 20px;
    h2{
        font-size: 16px;
        margin-top: 10px;
    }
    span{
        font-size: 14px;
    }
}

.successTip{
    text-align: center;
    padding: 20px;
}

.stepComponent{
    padding-top: 12px;
}

.submitBtn{
    text-align: center;
    .ant-btn{
        width: 97%;
        height: 34px;
        border-color: #f49b23;
        background-color: #f49b23;
        color: #ffffff;
        border-radius: 6px;
        margin-bottom: 10px;
    }
    .ant-btn:hover, .ant-btn:focus{
        border-color: #f49b23;
    }
    .backBtn{
        .ant-btn{
            border-color: #959595;
            background-color: #f5f7fa;
            color: #959595;
        }
        .ant-btn:hover, .ant-btn:focus{
            border-color: #959595;
        }
    }
}

.getCodeBtn{
    .ant-btn{
            width: 100%;
            border-color: #f5c17a;
            background-color: #f5c17a;
            color: #333333;
            margin-left: 10px;
        }
        .ant-btn:hover, .ant-btn:focus{
            border-color: #f5c17a;
        }
}
.disabledBtn{
    .ant-btn{
            width: 100%;
            border-color: #f5f7fa;
            background-color: #f5f7fa;
            color: #959595;
            margin-left: 10px;
        }
        .ant-btn:hover, .ant-btn:focus{
            border-color: #f5f7fa;
        }
}

.checkBox{
    div{
        margin-top: 7px;
    }
}

.radioTip{
    font-size: 14px;
    padding-left: 21px;
    padding-top: 5px;
}

.agreementText{
    color: #c86d02;
    text-decoration: underline;
    cursor: pointer;
}

/deep/.ant-modal-header{
    border: 0;
    padding-bottom: 0;
    border-radius: 10px;
}

/deep/.ant-modal-body{
    padding-top: 0px;
}

/deep/.ant-modal-content{
    border-radius: 10px !important;
}

/deep/.ant-steps-item-title{
    font-size: 12px;
    font-family: 'Roboto-Bold';
    line-height: 15px;
    word-wrap: break-word;
    text-wrap: wrap;
    padding-bottom: 5px;
}

/deep/.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title{
    color: #f49b23;
}


/deep/.ant-steps-item-process .ant-steps-item-icon{
    background-color: #f49b23;
    border-color: #f49b23;
}

/deep/.ant-steps-item-description{
    font-size: 12px;
    line-height: 12px;
}

/deep/.ant-steps-item-icon{
    width: 23px;
    height: 23px;
    line-height:23px;
}

/deep/.ant-select-open .ant-select-selection{
    border-color: #f49b23;
    box-shadow: none;
}

/deep/.ant-select-selection:hover{
    border-color: #f49b23;
}

/deep/.ant-select-dropdown-menu-item .ant-select-dropdown-menu-item-active{
    background-color: #f5c17a !important;
}

/deep/.ant-radio-wrapper{
    margin-top: 10px;
}

/deep/.ant-radio-inner{
    border-color: #484b4f;
}

/deep/.ant-radio-inner::after{
    width: 7px !important;
    height: 7px !important;
    top: 3.5px !important;
    left: 3.5px !important;
    background-color: #484b4f !important;
}


/deep/.ant-radio-checked::after{
    border-color: #484b4f;
}

/deep/.ant-radio-input:focus + .ant-radio-inner{
    box-shadow: none;
}

/deep/.ant-radio-wrapper:hover .ant-radio, .ant-radio:hover .ant-radio-inner, .ant-radio-input:focus + .ant-radio-inner{
    border-color: red !important;
}

/deep/.ant-input:hover,.ant-input:focus{
    border-color: #f49b23;
    box-shadow: none;
}

/deep/.ant-cascader-picker-show-search .ant-cascader-input.ant-input{
    box-shadow: none;
}

/deep/.ant-calendar-picker-input:hover{
    border-color: #f49b23 !important;
}

/deep/.ant-steps-item-finish .ant-steps-item-icon{
    border-color: #56c568;
}

/deep/.ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon{
        color: #56c568;
}

/deep/.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after{
    top: 8px !important;
}
/deep/.ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after{
    top: 8px !important;
}

/deep/.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after{
    top: 8px !important;
    background-color: #56c568;
}
/deep/.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-tail::after{
    top: 8px !important;
    background-color: #56c568;
}

/deep/.ant-steps-item-tail{
    left: 12px !important;
    top: -5px !important;
}

/deep/.ant-checkbox-checked .ant-checkbox-inner{
    background-color: #484b4f;
    border-color: #484b4f;
}
/deep/.ant-checkbox-wrapper:hover .ant-checkbox-inner, .ant-checkbox:hover .ant-checkbox-inner, .ant-checkbox-input:focus + .ant-checkbox-inner{
    border-color: #484b4f;
}
/deep/.ant-checkbox-checked::after{
    border-color: #484b4f;
}


@media (max-width: 992px){
    /deep/#modalTitle{
        font-size: 15px;
        span{
            font-size: 18px;
        }
    }
    /deep/.ant-steps-item-title{
        font-size: 16px;
    }
    /deep/.ant-steps-item-description{
        width: 100%;
        font-size: 15px;
        line-height: 16px;
    }
    /deep/.ant-steps-item-container{
        height: 62px;
    }
    .tip{
        font-size: 14px;
    }
    .getCodeBtn{
        .ant-btn{
                margin-left: 0px;
                margin-top: 10px;
            }
    }
    .disabledBtn{
        .ant-btn{
                margin-left: 0px;
                margin-top: 10px;
            }
    }
    .submitTip{
        h2{
            font-size: 16px;
        }
        span{
            font-size: 14px;
        }
    }
}


@media (max-width: 767px){
    
    
    .tip{
        margin-top: 5px;
    }
}

@media (max-width: 480px){
    /deep/.ant-steps-item-container{
        height: 80px;
    }
}
</style>